import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { InsectaServiceBase } from '../insecta.base.service';
import { IPermission, IRole, IRolePermission, IRolePermissionUpdateRequest } from '../insecta.models';

@Injectable({
  providedIn: 'root'
})
export class PermissionAdminService extends InsectaServiceBase {
  public getRoles(): Observable<IRole[]> {
    return this.get<IRole[]>(`/admin/roles`, 'v1').pipe(map((results) => [...results].sort((a: IRole, b: IRole) => a.name.localeCompare(b.name))));
  }

  public getPermissions(): Observable<IPermission[]> {
    return this.get<IPermission[]>(`/admin/permissions`, 'v1').pipe(
      map((results) => [...results].sort((a: IPermission, b: IPermission) => a.name.localeCompare(b.name)))
    );
  }

  public getRolePermissionsByRoleId(id: string): Observable<IRolePermission[]> {
    return this.get<IRolePermission[]>(`/admin/rolepermissions/${id}`, 'v1');
  }

  public updateRolePermissions(rolePermissions: IRolePermissionUpdateRequest): Observable<void> {
    return this.put<void>(`/admin/rolepermissions`, `v1`, rolePermissions);
  }

  updateAppUserTable() {
    return this.post<void>('/appuser/refresh', 'v1', {});
  }
}
